











import {
    Component,
    VueComponent,
    InjectComponent,
    Prop
} from "@zoovu/runner-browser-api";
import RadioButtonAnswerView from './radio-button-answer.vue';

@Component({})
export default class FilterRadioButtonAnswerView extends RadioButtonAnswerView {

    @Prop()
    showDisabledAnswers: boolean;

    @Prop()
    hideOptionLabels: boolean;

    @InjectComponent("FilterChoiceAnswerView")
    filterChoiceAnswer: VueComponent;
}
